import React from 'react';
import { Cell } from 'fixed-data-table';
import Util from '../Util';

class TextCell extends React.Component {
  render() {
    const { rowIndex, field, dataList, postfix, hoverTextField, isYN, style, ...rest } = this.props;
    let obj = dataList[rowIndex];
    let value = obj[field];
    let hoverValue = obj[hoverTextField];
    let opacity = Util.calcHostInfoRowOpacity(obj);

    if (typeof value === 'boolean' && isYN) {
      value = value ? 'Yes' : 'No';
    }
    if (postfix) value = value + ' ' + postfix;
    return (
      <Cell {...rest} style={{ opacity, ...style }}>
        <span title={hoverValue || value}>{value}</span>
      </Cell>
    );
  }
}

export default TextCell;



// WEBPACK FOOTER //
// ./src/components/TextCell.js